/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { useState } from 'react'
import { graphql } from 'gatsby'

// Elements
import ButtonDefault from 'components/elements/ButtonDefault'
import HeroDefault from 'components/elements/HeroDefault'
import Innovation from 'components/elements/Innovation'
import OtherService from 'components/elements/OtherService'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import ParseContent from 'components/shared/ParseContent'
import ImageBackground from 'components/shared/ImageBackground'

// Images
import IconUp from 'img/icon-up.svg'
import IconDown from 'img/icon-down.svg'

// Third Party
import styled from 'styled-components'

const PageTemplate = ({
  data: {
    page: { path, yoast_meta: yoast, acf },
  },
}) => {
  const [active, setActive] = useState(null)

  return (
    <Layout activePage={'/over-vmt/'}>
      <SEO yoast={yoast} path={path} article />

      <HeroDefault fields={acf.banner} />
      
      <div className="container d-flex  justify-content-between flex-wrap mt-3 mb-5">
        {acf.usps.map(({ title, description }, index) => {
          return (
            <DropDowns
              key={title}
              title={title}
              description={description}
              expanded={index === active}
              onExpand={() => setActive(index === active ? -1 : index)}
            />
          )
        })}
      </div>
      <GrayBlock>
        <div className="position-absolute w-100">
          <div className="container d-flex">
            <GrayImage src={acf.image} className="col-lg-10 mx-auto" />
          </div>
        </div>
      </GrayBlock>
      <WorkAt className="py-3 py-lg-5">
        <div className="container d-flex justify-content-between">
          <h4 className="mb-0">WERKEN BIJ VMT?</h4>
          <ButtonDefault type="outline" className="text-center my-lg-auto" to='/over-vmt/vacatures'>
            Bekijk onze vacatures
          </ButtonDefault>
        </div>
      </WorkAt>

      <Innovation fields={acf.innovation} />
      
      <div className="py-lg-0 py-5" />

      <CarImage src={acf.sponsor.image} />
      
      <div className="container pt-5">
        <div className="row">
          <div className="col-lg-10">
            <StyledContent content={acf.sponsor.description} />
          </div>
          <div className="col-lg-2 align-items-end justify-content-lg-start justify-content-center d-flex pb-5">
            <StyledButtonDefault isCustom type="outline">
              <a href="https://www.richardverschoor.com" target="_blank">
                Meer informatie
              </a>
            </StyledButtonDefault>
          </div>
        </div>
      </div>
      <OtherService />
    </Layout>
  )
}

export const pageQuery = graphql`
  query($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      ...AboutUsPage
    }
  }
`

export default PageTemplate

const DropDowns = ({ title, description, expanded, onExpand }) => {
  return (
    <DropDownWrapper className="position-relative">
      <DropDownContainer expanded={expanded}>
        <h5 className="mb-4">{title}</h5>
        <Content className="px-2" content={description} />
      </DropDownContainer>
      <ArrowButton onClick={() => onExpand()}>
        {expanded ? (
          <img src={IconUp} alt="arrow" />
        ) : (
          <img src={IconDown} alt="arrow" />
        )}
      </ArrowButton>
    </DropDownWrapper>
  )
}

const StyledButtonDefault = styled(ButtonDefault)`
  position: relative;
  left: -200px;

  @media screen and (max-width: 991px) {
    margin-top: 50px;
    left: unset;
  }

  a {
    white-space: nowrap;
  }
`

const StyledContent = styled(ParseContent)`
  h2 {
    font-family: ${(props) => props.theme.font.family.secondary};
    font-size: ${(props) => props.theme.font.size.xxxl};
    color: ${(props) => props.theme.color.text.main};
    text-transform: uppercase;
    padding-bottom: 20px;
    margin-bottom: 40px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      width: 2000px;
      height: 5px;
      background-color: ${props => props.theme.color.face.main};
      right: 280px;
      bottom: 0;
    }

    @media screen and (max-width: 576px) {
      font-size: ${(props) => props.theme.font.size.xl};
    }
  }

  p {
    width: 70%;
    line-height: 30px;

    @media screen and (max-width: 991px) {
      width: unset;
    }
  }
`

const Content = styled(ParseContent)`
  h2 {
    font-family: ${(props) => props.theme.font.family.secondary};
    font-size: ${(props) => props.theme.font.size.xxxl};
    color: ${(props) => props.theme.color.text.main};
    text-transform: uppercase;
    padding-bottom: 20px;
    margin-bottom: 40px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      width: 2000px;
      height: 5px;
      background-color: ${props => props.theme.color.face.main};
      right: 280px;
      bottom: 0;
    }

    @media screen and (max-width: 576px) {
      font-size: ${(props) => props.theme.font.size.xl};
    }
  }

  p {
    line-height: 30px;
  }
`

const DropDownWrapper = styled.div`
  width: 300px;
  @media screen and (max-width: 768px) {
    margin: 0 auto 50px auto;
    width: 240px;
  }
`
const DropDownContainer = styled.div`
  color: ${(props) => props.theme.color.text.secondary};
  border: 1px solid ${(props) => props.theme.color.face.main};
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
  font-size: ${(props) => props.theme.font.size.s};
  line-height: ${(props) => props.theme.font.size.xm};
  padding: 20px;
  height: fit-content;
  max-height: ${(props) => (props.expanded ? '700px' : '65px')};
  overflow: hidden;
  transition: all 300ms ease;
  background: white;
  text-align: center;

  h5 {
    font-size: ${(props) => props.theme.font.size.m};
    font-weight: ${(props) => props.theme.font.weight.l};
  }
`

const ArrowButton = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  border: 1px solid ${(props) => props.theme.color.face.main};
  border-radius: 50%;
  position: absolute;
  margin-top: -20px;
  background: white;
  margin-left: calc(50% - 20px);
  img {
    margin: auto;
  }
`
const GrayImage = styled(ImageBackground)`
  height: 450px;
  margin-top: -200px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
`
const GrayBlock = styled.div`
  background: #10101010;
  margin-top: 300px;
  height: 360px;
`
const WorkAt = styled.div`
  background: ${(props) => props.theme.color.face.main};
  color: ${(props) => props.theme.color.text.light};
  h4 {
    font-family: ${(props) => props.theme.font.family.secondary};
    font-size: ${(props) => props.theme.font.size.xxl};
    line-height: 66px;
    text-align: left;
    @media screen and (max-width: 576px) {
      font-size: ${(props) => props.theme.font.size.xl};
      line-height: ${(props) => props.theme.font.size.xxl};
    }
  }
`
const CarImage = styled(ImageBackground)`
  position: relative;
  margin-top: -150px;
  height: 600px;
  width: 100%;
  background-size: 100% auto;
  background-position: top;
  @media screen and (max-width: 992px) {
    &:before {
      background-size: cover !important;
    }
  }

  @media screen and (max-width: 576px) {
    height: 300px;
  }
`